import produce from 'immer';
import { createActions, handleActions } from 'redux-actions';

import { Category } from 'typing/models';
import {
  AbstractPayload, BaseState, CategoriesState,
} from 'typing/store';

import { LIST_FEATURED_CATEGORIES, LIST_FRONT_VIEW_CATEGORIES } from 'utils/fetchs';

import { fetchStateGenerator } from './checkFetchReducerCreator';

export const {
  listFrontViewCategoriesRequest,
  listFrontViewCategoriesSuccess,
  listFrontViewCategoriesFailure,
  listFrontViewCategoriesClean,
} = createActions(
  {},
  ...fetchStateGenerator(LIST_FRONT_VIEW_CATEGORIES),
  { prefix: 'FRONT_VIEW_CATEGORIES' },
);

const INITIAL_STATE = {
  list: {
    data: [],
  },
  detail: null,
};

export const getFrontViewCategories = (storeSlug?: string) => (state: BaseState):
  Category[] => {
  if (state.stores.detail?.slug === storeSlug) {
    return state.front_view_categories.list.data;
  }

  return [];
};

export default handleActions<CategoriesState, AbstractPayload>({
  [listFrontViewCategoriesSuccess.toString()]: produce(
    (draft: CategoriesState, { payload }) => {
      draft.list.data = payload;
      draft.list.filter = undefined;
    },
  ),
}, INITIAL_STATE);
